module.exports = __webpack_public_path__ + "static/media/history_18.dd97fcf5.jpg";